import React, { useContext } from 'react'

export enum Themes {
  Light = 'light',
  Dark = 'dark',
}

type ISectionThemeContext = Themes

export const SectionThemeContext = React.createContext<ISectionThemeContext>(Themes.Light)

export const SectionThemeProvider = SectionThemeContext.Provider

export const useIsSectionThemeDark = () => useContext(SectionThemeContext) === Themes.Dark
